/**
 * @info https://github.com/evoluteur/colorpicker
 */

$(document).ready(function() {
	if(!$('input[name="config_widget_css"]').length){
		return false;
	}

	loadColors();
	applyColors();
	
    initColorPickers();
    initColorChange();

    saveColors()
});

function initColorChange() {
    $('#border-color, #text-color, .color_').on('change', function () {
		var colorId = $(this).attr('id');
		var newcolor = $(this).val();
		var color = $(this).attr('pre_value');
		$(this).attr('pre_value', newcolor);
		change_color_new(color, newcolor, colorId);
		saveColors();
	});
}

function initColorPickers() {
    $('.color_').each(function () {
        $(this).colorpicker({ showOn: 'button' });
    });
}

function change_color_new(hexcolor, hexnewcolor, colorId) {
	var debug = debugMode = false;
	var cssSelectors = {
		'header-color-1': ['div.widget .header-seller-info'],
		'header-color-2': ['div.widget .header-seller-info'],
		'header-text-color': ['div.widget .header-seller-info .seller-info'],
		'customer-message-color': ['.widget .content.web-chat .message-block div.message'],
		'customer-text-color': ['.widget .content.web-chat .message-block div.message'],
		'seller-message-color': ['.widget .content.web-chat .message-block.reply div.message'],
		'seller-text-color': ['.widget .content.web-chat .message-block.reply div.message'],
		'widget-icon-color-1': ['div.widget-icon'],
		'widget-icon-color-2': ['div.widget-icon'],
		'widget-border-color': ['div.widget-icon'],
	};

	if (hexcolor == undefined) return;
	var rgbcolor = hexToRgb(hexcolor);
	var rgbnewcolor = hexToRgb(hexnewcolor);
	rgbcolor = 'rgb(' + rgbcolor.r + ', ' + rgbcolor.g + ', ' + rgbcolor.b + ')';
	rgbnewcolor = 'rgb(' + rgbnewcolor.r + ', ' + rgbnewcolor.g + ', ' + rgbnewcolor.b + ')';

	var rgbcolor_for_search = rgbcolor.replace('rgb', 'rgba');
	rgbcolor_for_search = rgbcolor_for_search.replace(')', '');

	var rgbnewcolor_for_search = rgbnewcolor.replace('rgb', 'rgba');
	rgbnewcolor_for_search = rgbnewcolor_for_search.replace(')', '');

	var FILE = 'provider_color.css';

	var sheets = document.styleSheets,
		sheet,
		i = 0,
		imax = sheets.length,
		rule;

	for (; i < imax; i++) {
		sheet = sheets[i];
		if (sheet.href && sheet.href.indexOf(FILE) !== -1) {
			break;
		}
	}

	if (i === imax)
		throw new Error('File Not Found');

	i = 0;
	imax = sheet.cssRules.length;
	if (debugMode) console.info('imax:' + imax);

	for (; i < imax; i++) {
		var rule = sheet.cssRules[i];
		if (debugMode) console.info({
			colorId: colorId,
			cssSelectors: cssSelectors[colorId],
			selectorText: rule.selectorText,
			indexOf: cssSelectors[colorId].indexOf(rule.selectorText)
		});

		if (
			rule.selectorText.indexOf(cssSelectors[colorId][0]) > -1
			&& (rule.cssText.indexOf(rgbcolor) !== -1 || rule.cssText.indexOf(rgbcolor_for_search) !== -1)
		) {
			if (debugMode) console.info('str 498');
			for (q in rule.style) {
				if (!!rule.style[rule.style[q]]) {
					if (
						rule.style[rule.style[q]].indexOf(rgbcolor) !== -1 ||
						rule.style[rule.style[q]].indexOf(rgbcolor_for_search) !== -1
					) {
						rule.style[rule.style[q]] = rule.style[rule.style[q]].replace(rgbcolor, rgbnewcolor);
					}

				} else if (!!rule.style[q] && typeof rule.style[q] !== "function" && rule.style[q].length > 5) {

					if (rule.style[q].indexOf(rgbcolor) !== -1) {
						rule.style[q] = rule.style[q].replace(rgbcolor, rgbnewcolor);
					} else if (rule.style[q].indexOf(rgbcolor_for_search) !== -1) {
						var txt = rule.style[q].replace(rgbcolor_for_search, rgbnewcolor_for_search);
						rule.style[q] = txt;
					}
				}
			}
		}
	}
}

function hexToRgb(hex) {
	if (hex[0] == "#") hex = hex.substr(1);
	if (hex.length == 3) {
		var temp = hex; hex = '';
		temp = /^([a-f0-9])([a-f0-9])([a-f0-9])$/i.exec(temp).slice(1);
		for (var i = 0; i < 3; i++) hex += temp[i] + temp[i];
	}

	if (/^([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})$/i.exec(hex) == null) {
		return {
			r: 0,
			g: 0,
			b: 0
		}
	}

	var triplets = /^([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})$/i.exec(hex).slice(1);
	return {
		r: parseInt(triplets[0], 16),
		g: parseInt(triplets[1], 16),
		b: parseInt(triplets[2], 16)
	}
}

function saveColors() {
	var colors = new Object;
	$('.color_').each(function () {
		colors[$(this).attr('id')] = { 'color': $(this).val(), 'start_color': $(this).attr('start_value') };
	});

	$('input[name="config_widget_css"]').val(JSON.stringify(colors));
}

function loadColors() {
	var colors = $('input[name="config_widget_css"]').val();
	if (colors == '') return;
	colors = JSON.parse(colors);

	for (var p in colors) {
		$('#' + p).val(colors[p]['color']);
	}
}

function applyColors() {
	$('.color_').each(function () {
		var pre_value = checkColor($(this).attr('pre_value'));
		var new_value = checkColor($(this).val());
		change_color_new(pre_value, new_value, $(this).attr('id'));
		$(this).attr('pre_value', $(this).val());
	})
}

function checkColor(color) {
	var re = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
	if (re.test(color)) {
		return color;
	}
	return '#ffffff';
}